// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1dVLU","actions":"GroupTable_actions__3xsUP","deleteModalFooter":"GroupTable_deleteModalFooter__1v4aV"};